import SkeletonPulse from '@/context/ClipsContext/ClipSkeletonLoader/components/SkeletonPulse';

const ClipCardSkeleton: React.FC<{ showTopicTitle?: boolean }> = ({ showTopicTitle = true }) => {
  return (
    <div className="space-y-4">
      {showTopicTitle && <SkeletonPulse classname="h-6 w-1/2 rounded" />}

      <div className="flex items-center gap-6">
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={index}
            className="h-[235px] w-72 shrink-0 overflow-hidden rounded-xl border border-slate-200 bg-white"
            style={{ maxWidth: '298px' }}
          >
            <div className="relative">
              <SkeletonPulse classname="aspect-video w-full" />
              <SkeletonPulse classname="absolute bottom-2 right-2 size-6 rounded-full" />
            </div>

            <div className="p-4">
              <SkeletonPulse classname="mb-2 h-4 w-3/4 rounded" />
              <SkeletonPulse classname="h-4 w-full rounded" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClipCardSkeleton;
